export default __webpack_public_path__ + "static/media/member.e25c1ebb.png";